<app-control-wrapper [control]="fc" [errors]="errors" [isShowHelper]="isShowHelper">
  <label *ngIf="isShowLabel" for="hts" control-label>
    {{ "FORM_LABEL.INTERNATIONAL_HTS_CODE" | translate }}
  </label>
  <div control-wrapper class="number-block">
    <input
      type="text"
      [formControl]="fc"
      class="form-control"
      [id]="'hts'"
      [name]="'hts'"
      inputmode="numeric"
      autocomplete="on"
      [mask]="mask"
      [placeholder]="isShowPlaceholder ? '0000.00.0000' : ''"
      [appMaskErrorTooltip]="'MASK_ERROR.ONLY_DIGITS'"
      [maxMaskLength]="10"
    />
    <ng-container *ngIf="validationLoading">
      <span class="ng-spinner-loader"></span>
    </ng-container>
  </div>
</app-control-wrapper>
